import { get } from 'lodash-es';
import type { SetTeamsForAgencyError } from '@urbanx/agx.agencies.client';

const isMembershipError = (error: unknown): error is SetTeamsForAgencyError =>
  get(error, 'code') === 'AgencyMembershipInvalid';

export const getTeamSaveErrorMessage = (error: unknown): string =>
  isMembershipError(error) ? error.message : 'Error saving changes';
